<template>
    <b-card no-body class="mb-0">
        <h4 class="px-1 py-75 mb-0">Kasa Giriş Onayı Bekleyen Transferler</h4>
        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"
                    :settings="false"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import NetsisOperationsApi from '@/api/netsis-operations'
export default {
    components:{
        BCard
    },
    data(){
        return {
            buttons:[
                { text:"Onayla",key:"approve",icon:"CheckCircleIcon",variant:"primary",action:this.approve,},
            ],
            fields:[
                {name:'Çıkış Yapılan Kasa',key:'FromVaultName',thClass:'text-nowrap w-25',tdClass:'text-nowrap'},
                {name:'Hedef Kasa',key:'DestinationKasaAdi',thClass:'text-nowrap w-25',tdClass:'text-nowrap'},
                {name:'İşlemi Yapan',key:'SenderEmployeeFullName',thClass:'text-nowrap w-25',tdClass:'text-nowrap'},
                {name:'Tutar',key:'AmountValue',thClass:'text-nowrap vt-th-text-right w-25',tdClass:'text-nowrap text-right'},
            ]
        }
    },
    methods:{
        provider(data){
            return NetsisOperationsApi.TransferWaitingMyApprove(data)
        },
        approve(d){
            const text = `Bu işlem ${d.FromVaultName} kasasından ${d.DestinationKasaAdi} kasasına yapılacak olan ${d.AmountValue} tutarındaki işlemi onaylayacaktır ve geri alınamaz.`
            this.$confirm('Onaylamak istediğinize emin misiniz?',text).then(c => {
                if(c){
                    this.$refs.table.rowLoading(true)
                    NetsisOperationsApi.TransferApprove(d.Id).then(res => {
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                        this.$refs.table.rowLoading(false)
                        this.$result(res)
                    }).catch(err =>{
                        this.$refs.table.rowLoading(false)
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>